import { selectedValueGroupsStore } from 'stores/selectedValueGroupsStore/selectedValueGroupsStore'
import { smallStore } from 'stores/smallStore/smallStore'

selectedValueGroupsStore.subscribeToChanges(
  (s) => s.selectedValueGroups,
  () => {
    smallStore.setState((s) => ({ ...s, selectedPreset: null }))
  },
)
